import { types } from "../actions/types";

const initialState = {
    loadingProfiles: true,
    availableProfiles: {
        profiles: [],
        remaining_profiles: 0,
    },
    selectedProfile: null,
    ttl: null
};

export const profileReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.loadingProfile:
            return {
                ...state,
                loadingProfiles: action.payload
            }
        case types.setAvailableProfiles:
            return {
                ...state,
                availableProfiles: {
                    profiles: action.payload.profiles,
                    remaining_profiles: action.payload.remaining_profiles,
                },
            };
        case types.selectProfile:
            return {
                ...state,
                selectedProfile: action.payload.profile || null,
                ttl: action.payload.ttl ?? null
            };
        case types.updateTTL:
          return {
            ...state,
            ttl: action.payload || null
          }
        default:
            return state;
    }
};
